 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		81: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendor~block-45~block-49~block-55~block-58~page-0~page-1~widget-0","1":"vendor~block-2~block-45~block-56~block-58~block-61~block-63","2":"vendor~block-51~block-56~block-58~block-6","3":"block-0","4":"block-1","5":"block-10","6":"block-11","7":"block-12","8":"block-13","9":"block-14","10":"block-15","11":"block-16","12":"block-17","13":"block-18","14":"block-19","15":"block-2","16":"block-20","17":"block-21","18":"block-22","19":"block-23","20":"block-24","21":"block-25","22":"block-26","23":"block-27","24":"block-28","25":"block-29","26":"block-3","27":"block-30","28":"block-31","29":"block-32","30":"block-33","31":"block-34","32":"block-35","33":"block-36","34":"block-37","35":"block-38","36":"block-39","37":"block-4","38":"block-40","39":"block-41","40":"block-42","41":"block-43","42":"block-44","43":"block-45","44":"block-46","45":"block-47","46":"block-48","47":"block-49","48":"block-5","49":"block-50","50":"block-51","51":"block-52","52":"block-53","53":"block-54","54":"block-55","55":"block-56","56":"block-57","57":"block-58","58":"block-59","59":"block-6","60":"block-60","61":"block-61","62":"block-62","63":"block-63","64":"block-64","65":"block-65","66":"block-66","67":"block-67","68":"block-68","69":"block-69","70":"block-7","71":"block-70","72":"block-71","73":"block-72","74":"block-73","75":"block-8","76":"block-9","77":"page-0","78":"page-1","79":"page-2","83":"theme-switcher","84":"widget-0","85":"widget-1","86":"widget-10","87":"widget-11","88":"widget-12","89":"widget-13","90":"widget-14","91":"widget-2","92":"widget-3","93":"widget-4","94":"widget-5","95":"widget-6","96":"widget-7","97":"widget-8","98":"widget-9"}[chunkId]||chunkId) + "." + {"0":"b8e56f8977e0adc118e1","1":"c47361ddc56fb5633d3d","2":"fe4e84c8dc159d8b35b6","3":"c0d487a830fb3ee329e9","4":"ccfc310d5584cafade60","5":"350576666d7f7ebf609b","6":"e09b9319deacd73e0421","7":"88f7c5ec7e5d6d54b7de","8":"dd1e39a853ea66107438","9":"cfc24c79249fdbd3885c","10":"1ab5667c0de338374a8e","11":"560bb94ecfde82c40697","12":"c688c2f9bf2acb6f9ff3","13":"0a0ceabc9755ce811306","14":"4d850238db3764d9d820","15":"06835d6b84e160bd94d9","16":"fa7b740478ef4a4965a3","17":"3f6e946f4aa09256259e","18":"1969810b64e96c342fa8","19":"07299fe79963bb28e341","20":"7f439e717f5ec40e0864","21":"4940986336f7dbcee3bf","22":"de372d0694ca59395262","23":"86a7649dd136d2153d75","24":"3ac10f0d82af08765793","25":"d254ef936f8a42f7a921","26":"f7ef43a67e3cd51550de","27":"2bb265387b84d80df3bb","28":"bef5896423744369e487","29":"3d2150364cd23c596f28","30":"aac6d4f946a72e7e5379","31":"e5f74003b5843d572f80","32":"f56b2197d4ab8e1eca09","33":"5bb600522c19a6f2243a","34":"45104f002c524f73ed94","35":"712d6d234ca187f69f0a","36":"45a28e18d69bbdecce48","37":"0391f5e18e95b1060474","38":"8e82d8ea023de297c884","39":"914663445c40c289fbb8","40":"ef0cffcf5fc67f50f487","41":"a0e56879d85e402852c0","42":"cf5263c0cd9ff3e61c60","43":"b91e69db1798f7bfc4d9","44":"c0b23bc8c0e9ec90969f","45":"c223faf5f248a117a7ea","46":"22e1960597cbe1f39414","47":"5e2b117ed3e04edcb7de","48":"36eb895e69a420287d36","49":"1a91fcfab71f54d5dee4","50":"c4708d81141a5be495b0","51":"5e5fd1e36cae8156f6e3","52":"58e2650cce056c9f112d","53":"591b1ef03e09941cbc81","54":"14d5aa65e0b74eb77a9c","55":"2f07046b7c88f612679f","56":"d767489492c37ac7ad2b","57":"b5c48bc8489fa4620ab8","58":"8d765e2b98c712ee4e61","59":"40edf0f1998d12ed57fd","60":"54fa090ea9d5d453bf00","61":"2df29410aefe6284df92","62":"41dd529643b48e327dc5","63":"2fb843b9a54d813e9b36","64":"968ce3f349580b201050","65":"6490d2a73e61185f3273","66":"7c3d79b323bb8d9ef06d","67":"fc83c960ea4aea577dd7","68":"4392d60e09d44e904c33","69":"87c0c11e6bdcea03f7af","70":"9637da0823a7e5a28f5f","71":"f9062297d7542fecb496","72":"e43e387416aa674111ad","73":"fad5f8296cf7f90b8f87","74":"5db1831e659c795b0ecb","75":"71aa4d7e1dbef1cf04fa","76":"20a0041b56e4be95cb23","77":"ef0d7e62d4a5e7f0599f","78":"bfa28338cd858603b64e","79":"8349e52ad064c7a84d6d","83":"d38e495303a0d685df8b","84":"00fbf4212b2dfa3b9b71","85":"8a9016eda5b9929ec27f","86":"d416ed90615ec18d7931","87":"fdd9e44b6bd000cb400f","88":"fae05c2f7952d2ea1192","89":"50d8cb052d6c8e43ee36","90":"4dfc0243fbc3c7cdcd62","91":"1a3c6f9b9d755043b174","92":"0653f47d41e89083b157","93":"3d386e37da8dd60a0e7f","94":"43cabb34c663c100a1bf","95":"3905d40d28b37f546581","96":"c9889628e4123e7ff6d1","97":"5b5cb05204f4efad5add","98":"ac2eaec8e3dc7757bf16"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/js/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 8);
